import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  rowLink: {
    fontSize: theme.fonts.medium.fontSize,
    color: theme.semanticColors.bodyText,
    ':focus': {
      color: theme.semanticColors.bodyText,
    },
  },
  statusText: {
    color: theme.palette.accent,
  },

  
  contentColumnAlignRight: {
    display: 'block',
    textAlign: 'right',
  },
  footerRow: {
    backgroundColor: theme.palette.neutralLighter,
  },
  amountStack: {
    fontWeight: 'bold',
  },
  onrenderColumnStack: {
    height: 25,
  },
  rowBaseStyle: { borderLeft: `5px solid transparent` },
  container: { maxWidth: 300, minWidth: 200 },
  containerMain: { padding: 0, margin: 0 },
  title: { color: '#fff' },
  urgentHeader: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '5px 10px',
    backgroundColor: `${theme.palette.redDark}`,
  },
}));
